//TODO: To be fetched from metadata end-point in the future
export const STATUS_IDS = {
    pending: 1,
    active: 2,
    disabled: 3,
}